












































































import Engine from "@gaia-project/engine";
import { PlayerColumn } from "src/logic/table/types";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { HistoryEntry, makeHistory } from "../data/log";
import { RichText } from "../graphics/rich-text";
import { logPlayerTables } from "../logic/table/player";
import { cellStyle } from "../logic/table/util";
import { parseRewardsForLog } from "../logic/utils";
import RichTextView from "./Resources/RichTextView.vue";

type LogScope = "recent" | "all";
@Component({
  components: { RichTextView },
})
export default class AdvancedLog extends Vue {
  private scope: LogScope = "recent";

  @Prop()
  currentMove?: string;

  @Prop()
  hideLog?: boolean;

  mounted() {
    const keyListener = (e) => {
      switch (e.key) {
        case "h":
          this.toggleLog();
          break;
        case "y":
          this.toggleScope();
          break;
      }
    };
    window.addEventListener("keydown", keyListener);
    this.$on("hook:beforeDestroy", () => window.removeEventListener("keydown", keyListener));
  }

  toggleLog() {
    this.$emit("update:hideLog", !this.hideLog);
  }

  toggleScope() {
    this.scope = this.scope == "all" ? "recent" : "all";
  }

  replayTo(moveIndex: number) {
    this.$store.dispatch("replayTo", moveIndex + 1);
  }

  get engine(): Engine {
    return this.$store.state.data;
  }

  get extendedLog(): boolean {
    return this.$store.state.preferences.extendedLog;
  }

  get history(): HistoryEntry[] {
    if (this.hideLog) return [];

    return makeHistory(
      this.engine,
      this.$store.getters.recentMoves,
      this.scope == "recent",
      this.currentMove,
      this.extendedLog
    );
  }

  rowSpan(entry: HistoryEntry): number {
    return entry.changes.length > 0 ? entry.changes.length : 1;
  }

  get rowHeaders(): PlayerColumn[] {
    return this.extendedLog ? logPlayerTables(this.engine).flatMap((t) => t.columns) : [];
  }

  cellStyle(c: PlayerColumn): string {
    return `${cellStyle(c.color)} border: 1px`;
  }

  parseRewards(s: string): RichText {
    return parseRewardsForLog(s);
  }

  rowValues(entry: HistoryEntry, change: number): { value: RichText; leftBorder: boolean }[] {
    if (!this.extendedLog || change > 1) {
      return [];
    }

    return entry.rows
      ? entry.rows.flatMap((r) =>
          r.map((value, i) => ({
            value,
            leftBorder: i == 0,
          }))
        )
      : logPlayerTables(this.engine).flatMap((t) =>
          t.columns.map((c, i) => ({
            value: [],
            leftBorder: i == 0,
          }))
        );
  }
}
